import { useQuery } from '@tanstack/react-query';
import api from '@app/services/api';
import { apiEndpoints } from '@app/utils/constants';
import type { UseQueryOptions } from '@tanstack/react-query';
import type { ApiError, UserViewParams, UserViewResponse } from '@app/services/api.types';

type QueryOptions = Omit<UseQueryOptions<UserViewResponse, ApiError>, 'queryKey' | 'queryFn'>;

export const fetchUser = async ({ id }: UserViewParams) => {
	const url = apiEndpoints.users.getSingle(id);
	const response = await api.get<UserViewResponse>(url);
	return response?.data;
};

const useUser = (params: UserViewParams, options?: QueryOptions) => {
	return useQuery<UserViewResponse, ApiError>({
		queryKey: ['user', 'single', params],
		queryFn: () => fetchUser(params),
		...options,
		enabled: Boolean(params.id),
	});
};

export default useUser;
